import { appComponents } from "./app-components"
import { authComponents } from "./auth-components"

export { appComponents, authComponents }

export const components = {
  ...appComponents,
  ...authComponents,
}
